/**
 * Date helpers that avoid UTC drift for plain YYYY-MM-DD values
 * (e.g. contract_expiration_date). A bare date string parsed with
 * `new Date("2026-09-01")` is UTC midnight, which renders as the
 * previous day in western timezones.
 */

const DATE_ONLY_RE = /^\d{4}-\d{2}-\d{2}$/;

export function parseLocalDate(value: string | Date | null | undefined): Date | null {
  if (value === null || value === undefined || value === "") return null;
  if (value instanceof Date) return value;
  if (typeof value === "string" && DATE_ONLY_RE.test(value)) {
    const [y, m, d] = value.split("-").map(Number);
    return new Date(y, m - 1, d);
  }
  const parsed = new Date(value);
  return isNaN(parsed.getTime()) ? null : parsed;
}

export function formatLocalDate(
  value: string | Date | null | undefined,
  opts: Intl.DateTimeFormatOptions = { year: "numeric", month: "short", day: "numeric" }
): string {
  const d = parseLocalDate(value);
  if (!d) return "N/A";
  return d.toLocaleDateString("en-US", opts);
}
